import { adminRoutes } from 'modules/admin/routes/constants';

export const postEditorRoutes = {
  root: `${adminRoutes.root}/post-editor`,
  editPost: `${adminRoutes.root}/post-editor/edit/:id`,
  createPost: `${adminRoutes.root}/post-editor/create`,
  restorePost: `${adminRoutes.root}/post-editor/restore`,
};
